import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/database';

// Hardcoded for now - will move to env vars for production
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://jcurqdvrxlwfeemrxwth.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpjdXJxZHZyeGx3ZmVlbXJ4d3RoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc3MzIzNjQsImV4cCI6MjA4MzMwODM2NH0.EtNhhKx2ofPRWHtxDpY2FFmb2cG6yzIp73rKlPahGTY';

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

